import api from "../../api.js";

export async function updateProfile(patientId, payload) {
  const res = await api.put(`/api/profiles/update/${encodeURIComponent(patientId)}`, payload);
  return res.data;
}

export async function setProfileEnabled(patientId, enabled) {
  const res = await api.patch(`/api/profiles/enabled/${encodeURIComponent(patientId)}`, { enabled });
  return res.data;
}
